import React from "react";
import "./FlightResultsLoadingSkeleton.css";

const SKELETON_CARD_COUNT = 4;

function FlightSkelLeg() {
  return (
    <div className="fw-flight-skel-card__leg">
      <div className="fw-flight-skel-card__leg-head">
        <span className="fw-skel-line fw-skel-line--leg-title" />
        <span className="fw-skel-line fw-skel-line--date" />
      </div>
      <div className="fw-flight-skel-card__route">
        <span className="fw-skel-line fw-skel-line--time" />
        <span className="fw-skel-line fw-skel-line--path" />
        <span className="fw-skel-line fw-skel-line--time" />
        <span className="fw-skel-line fw-skel-line--meta" />
      </div>
    </div>
  );
}

function FlightResultCardSkeleton() {
  return (
    <article className="fw-flight-skel-card" aria-hidden="true">
      <aside className="fw-flight-skel-card__airline">
        <span className="fw-skel-logo" />
        <span className="fw-skel-line fw-skel-line--airline" />
      </aside>
      <section className="fw-flight-skel-card__details">
        <FlightSkelLeg />
        <FlightSkelLeg />
      </section>
      <aside className="fw-flight-skel-card__price">
        <span className="fw-skel-line fw-skel-line--price" />
        <span className="fw-skel-line fw-skel-line--caption" />
        <span className="fw-skel-cta" />
      </aside>
    </article>
  );
}

/**
 * Results-page placeholder while a planes search is in flight:
 * filter toolbar + flight cards (price / legs / airline).
 */
export default function FlightResultsLoadingSkeleton({
  count = SKELETON_CARD_COUNT,
}) {
  const safeCount = Number.isFinite(Number(count))
    ? Math.min(6, Math.max(3, Number(count)))
    : SKELETON_CARD_COUNT;

  return (
    <div
      className="fw-results-loading-skeleton"
      dir="rtl"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="fw-results-loading-skeleton__sr">
        טוענים תוצאות טיסה...
      </span>
      <div className="fw-results-loading-skeleton__filters" aria-hidden="true">
        <div className="fw-results-loading-skeleton__toolbar">
          <span className="fw-skel-line fw-skel-line--sort" />
          <span className="fw-skel-line fw-skel-line--count" />
        </div>
        <div className="fw-results-loading-skeleton__chips">
          <span className="fw-skel-chip" />
          <span className="fw-skel-chip" />
          <span className="fw-skel-chip fw-skel-chip--short" />
        </div>
      </div>
      <ul className="fw-results-loading-skeleton__list">
        {Array.from({ length: safeCount }, (_, index) => (
          <li key={`flight-results-skel-${index}`}>
            <FlightResultCardSkeleton />
          </li>
        ))}
      </ul>
    </div>
  );
}
